import type { ChatRoomResponseParticipantsItemBasicInfo } from './chatRoomResponseParticipantsItemBasicInfo';
import type { ChatRoomResponseParticipantsItemSocial } from './chatRoomResponseParticipantsItemSocial';

/**
 * 간략한 사용자 정보
 */
export type ChatRoomResponseParticipantsItem = {
  /** 사용자 기본 정보 */
  basicInfo: ChatRoomResponseParticipantsItemBasicInfo;
  /** 소셜 관계 정보 */
  social?: ChatRoomResponseParticipantsItemSocial;
};
